module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [(_vm.bquery) ? _c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "企业名称"
    },
    model: {
      value: (_vm.filters.companyName),
      callback: function($$v) {
        _vm.$set(_vm.filters, "companyName", $$v)
      },
      expression: "filters.companyName"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.bquery) ? _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.getPageList
    }
  }, [_vm._v("查询")])], 1) : _vm._e(), _vm._v(" "), (_vm.bshow) ? _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.showAddyhpcRecord
    }
  }, [_vm._v("上传排查记录")])], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.pagelist,
      "highlight-current-row": ""
    }
  }, [(_vm.bquery) ? _c('el-table-column', {
    attrs: {
      "prop": "coName",
      "label": "企业名称",
      "min-width": "200",
      "align": "center"
    }
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "checkTime",
      "label": "实际排查日期",
      "align": "center",
      "min-width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "selfCheckLocationName",
      "label": "排查场所",
      "align": "center",
      "min-width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "riskLevelName",
      "label": "风险等级",
      "align": "center",
      "min-width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "workerName",
      "label": "排查人",
      "align": "center",
      "min-width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "checkStatusName",
      "label": "排查状态",
      "align": "center",
      "min-width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "checkResult",
      "label": "排查结果",
      "align": "center",
      "min-width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "planCorrectTime",
      "label": "整改计划完成时间",
      "align": "center",
      "min-width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "correctUserName",
      "label": "整改负责人",
      "align": "center",
      "min-width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "correctContent",
      "label": "整改措施",
      "align": "center",
      "min-width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "correctTime",
      "label": "整改完成时间",
      "align": "center",
      "min-width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "reviewUserName",
      "label": "验收人",
      "align": "center",
      "min-width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "reviewContent",
      "label": "验收内容",
      "align": "center",
      "min-width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "reviewTime",
      "label": "验收时间",
      "align": "center",
      "min-width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "align": "left",
      "width": "300"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.selfCheckDetail(scope.$index, scope.row)
            }
          }
        }, [_vm._v("排查详情")]), _vm._v(" "), (_vm.bshow && (scope.row.checkStatusName == '不合格')) ? _c('el-button', {
          attrs: {
            "type": "warning",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleUploadPic(scope.$index, scope.row)
            }
          }
        }, [_vm._v("上传隐患照片")]) : _vm._e(), _vm._v(" "), (_vm.bshow && (scope.row.checkStatusName == '已整改')) ? _c('el-button', {
          attrs: {
            "type": "warning",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleUploadPic(scope.$index, scope.row)
            }
          }
        }, [_vm._v("上传整改照片")]) : _vm._e(), _vm._v(" "), (_vm.bshow && (scope.row.checkStatusName == '不合格')) ? _c('el-button', {
          attrs: {
            "type": "success",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleZG(scope.$index, scope.row)
            }
          }
        }, [_vm._v("整改完成")]) : _vm._e(), _vm._v(" "), (_vm.bshow && (scope.row.checkStatusName == '已整改')) ? _c('el-button', {
          attrs: {
            "type": "success",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleYS(scope.$index, scope.row)
            }
          }
        }, [_vm._v("验收完成")]) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "total,prev, pager, next",
      "page-size": 20,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "隐患排查详情",
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.detailFormVisible),
      callback: function($$v) {
        _vm.detailFormVisible = $$v
      },
      expression: "detailFormVisible"
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple"
  }, [_c('label', [_vm._v("企业名称:  " + _vm._s(_vm.detailForm.coName))])]), _vm._v(" "), _c('div', {
    staticClass: "grid-content"
  }, [_c('label', [_vm._v("排查日期:  " + _vm._s(_vm.detailForm.checkTime) + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "grid-content bg-purple-light"
  }, [_c('label', [_vm._v("检查状态:  " + _vm._s(_vm.detailForm.checkStatusName) + " ")])]), _vm._v(" "), (_vm.detailForm.selfCheckType == '0') ? _c('div', [_c('div', {
    staticClass: "grid-content bg-purple-light"
  }, [_c('label', [_vm._v("排查结果:  " + _vm._s(_vm.detailForm.checkResult) + " ")])]), _vm._v(" "), (_vm.picList0.length != 0) ? _c('div', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('label', [_vm._v("隐患照片")])]) : _vm._e(), _vm._v(" "), (_vm.picList0.length != 0) ? _c('div', [_c('div', {
    staticClass: "image-container"
  }, _vm._l((_vm.picList0), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "image-item"
    }, [_c('img', {
      attrs: {
        "src": _vm.picbaseurl + item.picUrl,
        "alt": "Image"
      },
      on: {
        "click": function($event) {
          if ($event.target !== $event.currentTarget) { return null; }
          return _vm.showBigImage(_vm.picbaseurl + item.picUrl)
        }
      }
    })])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.picList0.length != 0) ? _c('hr') : _vm._e(), _vm._v(" "), (_vm.picList1.length != 0) ? _c('div', {
    staticClass: "grid-content bg-purple"
  }, [_c('label', [_vm._v("整改照片")])]) : _vm._e(), _vm._v(" "), (_vm.picList1.length != 0) ? _c('div', [_c('div', {
    staticClass: "image-container"
  }, _vm._l((_vm.picList1), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "image-item"
    }, [_c('img', {
      attrs: {
        "src": _vm.picbaseurl + item.picUrl,
        "alt": "Image"
      },
      on: {
        "click": function($event) {
          if ($event.target !== $event.currentTarget) { return null; }
          return _vm.showBigImage(_vm.picbaseurl + item.picUrl)
        }
      }
    })])
  }), 0)]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.detailForm.selfCheckType == '1') ? _c('div', [_c('div', {
    staticClass: "grid-content bg-purple-light"
  }, [_c('label', [_vm._v("问题描述:  " + _vm._s(_vm.detailForm.checkResult) + " ")])]), _vm._v(" "), _vm._l((_vm.feedata), function(item, index) {
    return _c('div', {
      key: index,
      staticStyle: {
        "margin-top": "20px"
      }
    }, [_c('div', {
      staticClass: "grid-content bg-purple"
    }, [_c('label', [_vm._v(_vm._s(item.checkContent))])]), _vm._v(" "), _c('div', {
      staticClass: "grid-content bg-purple-light"
    }, [_c('label', [_vm._v("检查结果:  " + _vm._s(item.checkResult == '1' ? '合格' : '不合格') + " ")])]), _vm._v(" "), _c('div', {
      staticClass: "image-container"
    }, _vm._l((item.picList), function(picUrl) {
      return _c('div', {
        key: picUrl,
        staticClass: "image-item"
      }, [_c('img', {
        attrs: {
          "src": _vm.picbaseurl + picUrl,
          "alt": "Image"
        },
        on: {
          "click": function($event) {
            if ($event.target !== $event.currentTarget) { return null; }
            return _vm.showBigImage(_vm.picbaseurl + picUrl)
          }
        }
      })])
    }), 0), _vm._v(" "), _c('hr')])
  })], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.detailFormVisible = false
      }
    }
  }, [_vm._v("关闭")])], 1)]), _vm._v(" "), _c('BigImg', {
    attrs: {
      "visible": _vm.photoVisible,
      "url": _vm.bigImgUrl
    },
    on: {
      "closeClick": function () {
        _vm.photoVisible = false
      }
    }
  }), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.zgFormTitle,
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.zgFormVisible),
      callback: function($$v) {
        _vm.zgFormVisible = $$v
      },
      expression: "zgFormVisible"
    }
  }, [_c('el-form', {
    ref: "zgForm",
    attrs: {
      "model": _vm.zgForm,
      "label-width": "200px",
      "rules": _vm.zgFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "整改负责人"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.workerId),
      callback: function($$v) {
        _vm.workerId = $$v
      },
      expression: "workerId"
    }
  }, _vm._l((_vm.companymemberlist), function(item) {
    return _c('el-option', {
      key: item.Mpid,
      attrs: {
        "label": item.name + '(' + item.workerTypeName + ')',
        "value": item.workerId
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "整改完成日期",
      "prop": "correctTime"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": "选择日期",
      "value-format": "yyyy-MM-dd",
      "format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.zgForm.selCorrectTime),
      callback: function($$v) {
        _vm.$set(_vm.zgForm, "selCorrectTime", $$v)
      },
      expression: "zgForm.selCorrectTime"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "整改措施",
      "prop": "correctContent"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.zgForm.correctContent),
      callback: function($$v) {
        _vm.$set(_vm.zgForm, "correctContent", $$v)
      },
      expression: "zgForm.correctContent"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.zgFormVisible = false
      }
    }
  }, [_vm._v("关闭")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.editLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.updateZgInfo.apply(null, arguments)
      }
    }
  }, [_vm._v("保存")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.ysFormTitle,
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.ysFormVisible),
      callback: function($$v) {
        _vm.ysFormVisible = $$v
      },
      expression: "ysFormVisible"
    }
  }, [_c('el-form', {
    ref: "ysForm",
    attrs: {
      "model": _vm.ysForm,
      "label-width": "200px",
      "rules": _vm.ysFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "验收人"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.workerId),
      callback: function($$v) {
        _vm.workerId = $$v
      },
      expression: "workerId"
    }
  }, _vm._l((_vm.companymemberlist), function(item) {
    return _c('el-option', {
      key: item.Mpid,
      attrs: {
        "label": item.name + '(' + item.workerTypeName + ')',
        "value": item.workerId
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "验收日期",
      "prop": "reviewTime"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": "选择日期",
      "value-format": "yyyy-MM-dd",
      "format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.ysForm.selReviewTime),
      callback: function($$v) {
        _vm.$set(_vm.ysForm, "selReviewTime", $$v)
      },
      expression: "ysForm.selReviewTime"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "验收内容",
      "prop": "reviewContent"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.ysForm.reviewContent),
      callback: function($$v) {
        _vm.$set(_vm.ysForm, "reviewContent", $$v)
      },
      expression: "ysForm.reviewContent"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.ysFormVisible = false
      }
    }
  }, [_vm._v("关闭")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.editLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.updateYsInfo.apply(null, arguments)
      }
    }
  }, [_vm._v("保存")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.uploadpicTitle,
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.yhpicFormVisible),
      callback: function($$v) {
        _vm.yhpicFormVisible = $$v
      },
      expression: "yhpicFormVisible"
    }
  }, [_c('el-form', {
    ref: "yhpicForm",
    attrs: {
      "model": _vm.yhpicForm,
      "label-width": "100px",
      "rules": _vm.yhpicFormRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "上传照片"
    }
  }, [_c('div', [_c('input', {
    ref: "upLoadRef",
    attrs: {
      "type": "file"
    },
    on: {
      "change": function($event) {
        $event.stopPropagation();
        return _vm.handleFileUpload.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.uploadstart),
      expression: "uploadstart"
    }],
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.uploadReportFile.apply(null, arguments)
      }
    }
  }, [_vm._v("上传")])])]), _vm._v("\n\t\t\t\t请提前准备好照片，上传文件成功后，再点击保存。\n      \t\t")], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.yhpicFormVisible = false
      }
    }
  }, [_vm._v("关闭")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.yhpicLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.updateReportPic.apply(null, arguments)
      }
    }
  }, [_vm._v("保存")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "上传隐患排查记录",
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.addyhpcFormVisible),
      callback: function($$v) {
        _vm.addyhpcFormVisible = $$v
      },
      expression: "addyhpcFormVisible"
    }
  }, [_c('el-form', {
    ref: "addyhpcForm",
    attrs: {
      "label-position": _vm.labelPosition,
      "model": _vm.addyhpcForm,
      "label-width": "140px",
      "rules": _vm.addyhpcFormRules
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "排查场所"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.selfCheckLocationvalue),
      callback: function($$v) {
        _vm.selfCheckLocationvalue = $$v
      },
      expression: "selfCheckLocationvalue"
    }
  }, _vm._l((_vm.selfCheckLocationoptions), function(item) {
    return _c('el-option', {
      key: item.Mpid,
      attrs: {
        "label": item.MpCn,
        "value": item.MpValue
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "排查人员"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.workerId),
      callback: function($$v) {
        _vm.workerId = $$v
      },
      expression: "workerId"
    }
  }, _vm._l((_vm.companymemberlist), function(item) {
    return _c('el-option', {
      key: item.Mpid,
      attrs: {
        "label": item.name + '(' + item.workerTypeName + ')',
        "value": item.workerId
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-form-item', {
    attrs: {
      "label": "实际排查日期",
      "prop": "checkTime"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": "选择日期",
      "value-format": "yyyy-MM-dd",
      "format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.addyhpcForm.selCheckTime),
      callback: function($$v) {
        _vm.$set(_vm.addyhpcForm, "selCheckTime", $$v)
      },
      expression: "addyhpcForm.selCheckTime"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-form-item', {
    attrs: {
      "label": "排查结果",
      "prop": "checkResult"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addyhpcForm.checkResult),
      callback: function($$v) {
        _vm.$set(_vm.addyhpcForm, "checkResult", $$v)
      },
      expression: "addyhpcForm.checkResult"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-form-item', {
    attrs: {
      "label": "风险级别"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.riskLevelvalue),
      callback: function($$v) {
        _vm.riskLevelvalue = $$v
      },
      expression: "riskLevelvalue"
    }
  }, _vm._l((_vm.riskLeveloptions), function(item) {
    return _c('el-option', {
      key: item.Mpid,
      attrs: {
        "label": item.MpCn,
        "value": item.MpValue
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-form-item', {
    attrs: {
      "label": "整改计划完成时间",
      "prop": "planCorrectTime"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": "选择日期",
      "value-format": "yyyy-MM-dd",
      "format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.addyhpcForm.selPlanCorrectTime),
      callback: function($$v) {
        _vm.$set(_vm.addyhpcForm, "selPlanCorrectTime", $$v)
      },
      expression: "addyhpcForm.selPlanCorrectTime"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.addyhpcFormVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.handleAddyhpcRecord.apply(null, arguments)
      }
    }
  }, [_vm._v("提交")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-37fec928"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/nav/selfcheckRecord.vue
// module id = 827
// module chunks = 2